import { Routes, RouterModule } from '@angular/router';
import { MessageLayoutComponent } from '../layouts/';
import { ErrorsURLs } from './errors.url';
import { Outlets } from '../layouts/layouts.outlet';
import {
  IdentificationFailedComponent,
  InvalidSessionComponent,
  PageNotFoundComponent,
  InvalidTokenComponent,
  ChangePasswordFailedComponent,
  RequestFailedComponent,
  RequestFailedHelpComponent
} from '.';


const routes: Routes = [
  {
    path: ErrorsURLs.IDENTIFICATION_FAILED, component: MessageLayoutComponent, children: [
      { path: ErrorsURLs._BLANK, component: IdentificationFailedComponent, outlet: Outlets.MESSAGE },
      { path: '', component: RequestFailedHelpComponent, outlet: 'help' }
    ]
  },
  {
    path: ErrorsURLs.INVALID_TOKEN, component: MessageLayoutComponent, children: [
      { path: ErrorsURLs._BLANK, component: InvalidTokenComponent, outlet: Outlets.MESSAGE },
      { path: '', component: RequestFailedHelpComponent, outlet: 'help' }
    ]
  },
  {
    path: ErrorsURLs.CHANGE_PASSWORD_FAILED, component: MessageLayoutComponent, children: [
      { path: ErrorsURLs._BLANK, component: ChangePasswordFailedComponent, outlet: Outlets.MESSAGE },
      { path: '', component: RequestFailedHelpComponent, outlet: 'help' }
    ]
  },
  {
    path: ErrorsURLs.INVALID_SESSION, component: MessageLayoutComponent, children: [
      { path: ErrorsURLs._BLANK, component: InvalidSessionComponent, outlet: Outlets.MESSAGE }
      /*{ path: '', component: null, outlet: 'help' }*/
    ]
  },
  {
    path: ErrorsURLs.PAGE_NOT_FOUND, component: MessageLayoutComponent, children: [
      { path: ErrorsURLs._BLANK, component: PageNotFoundComponent, outlet: Outlets.MESSAGE }
      /* { path: 'page-not-found-help', component: CommonErrorHelpComponent, outlet: 'help' }*/
    ]
  },
  {
    path: ErrorsURLs.REQUEST_FAILED, component: MessageLayoutComponent, children: [
      { path: ErrorsURLs._BLANK, component: RequestFailedComponent, outlet: Outlets.MESSAGE },
      { path: '', component: RequestFailedHelpComponent, outlet: 'help' }
    ]
  }
];

export const ErrorsRoutes = RouterModule.forChild(routes);
